<template>
    <app-data-table
        :fields="fields"
        :items="normalizedData.data || []"
        @sort="onSort"
        :current-page="normalizedData.current_page"
        :last-page="normalizedData.last_page"
        :from="normalizedData.from"
        :to="normalizedData.to"
        :total="normalizedData.total"
        :per-page="normalizedData.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="expiry_date" slot-scope="{ item }">
            {{ item.expiry_date ? 'Sí' : 'No' }}
        </template>
        <template slot="status" slot-scope="{ item }">
            <span :class="item.status === 'active' ? 'text-success' : 'text-secondary'">
                {{ item.status === 'active' ? 'Activo' : 'Inactivo' }}
            </span>
        </template>
        <template slot="actions" slot-scope="{ item }">
            <b-button variant="primary" size="sm" @click="onEdit(item)">
                <i class="fa fa-edit" aria-hidden="true"></i>
            </b-button>
            <b-button variant="danger" size="sm" @click="onDelete(item)">
                <i class="fa fa-trash" aria-hidden="true"></i>
            </b-button>
        </template>
    </app-data-table>
</template>
<script>
export default {
    data() {
        return {
            fields: [
                { key: 'code', label: 'Código', sortable: true },
                { key: 'name', label: 'Nombre', sortable: true },
                { key: 'expiry_date', label: 'Requiere vencimiento', sortable: false },
                { key: 'status', label: 'Estado', sortable: true },
                { key: 'actions', label: 'Acciones' }
            ]
        };
    },
    props: {
        data: {
            type: [Object, Array],
            default: () => ({ data: [], current_page: 1, last_page: 1, per_page: 15, total: 0, from: null, to: null })
        },
        onEdit: { type: Function, required: true },
        onDelete: { type: Function, required: true },
        onChangePage: { type: Function, required: true }
    },
    computed: {
        normalizedData() {
            if (Array.isArray(this.data)) {
                return {
                    data: this.data,
                    current_page: 1,
                    last_page: 1,
                    per_page: this.data.length,
                    total: this.data.length,
                    from: this.data.length ? 1 : null,
                    to: this.data.length || null
                };
            }
            return this.data || { data: [], current_page: 1, last_page: 1, per_page: 15, total: 0, from: null, to: null };
        }
    },
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx);
        }
    }
};
</script>
